import { FieldValue } from 'app/components/commons/Hotel/Contacts/FieldView/FieldView';

type SelectOption = { id: string | number | boolean; name: string };

type Props = {
  value?: string | number | boolean;
  options: SelectOption[];
};

export const SelectValue = ({ value, options }: Props) => {
  const match = options.find((option) => option.id === value);

  return <FieldValue value={match?.name} />;
};
